import React, { useState } from 'react';
import { PageContainer, Button } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './setupAccount.css';

const SetupAccountNode = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10); // Keep only first 10 digits
  const parts = [];

  if (digits.length > 0) parts.push('(' + digits.slice(0, 3));
  if (digits.length >= 4) parts.push(')-' + digits.slice(3, 6));
  if (digits.length >= 7) parts.push('-' + digits.slice(6, 10));

  return parts.join('');
};

const handlePhoneChange = (e) => {
  const input = e.target.value;
  const formatted = formatPhone(input);
  setPhone(formatted);
  setPhoneError('');
};

const validatePhone = () => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length !== 10) {
    setPhoneError('Please enter a valid 10-digit phone number.');
  } else {
    setPhoneError('');
  }
};
  return (
    <PageContainer className="accountSetupNode-Container">
      <h2 className="accountSetupNode-title">
        Create Your Subscriber Connect Account
      </h2>
      <p className="accountSetupNode-desc">
        Your online Subscriber Connect account allows you to track your order,
        request support, and pay your bill.
      </p>
      <div className="accountSetupNode-formBox-container">
        <div className="accountSetupNode-formBox">
          <h3 className="accountSetupNode-boxTitle">Personal Information</h3>

          <div className="accountSetupNode-formRow">
            <div className="accountSetupNode-inputContainer accountSetupNode-firstName">
              <label className="accountSetupNode-label accountSetupNode-label-firstName">
                First Name
              </label>
              <input
                id={ELEMENT_IDS.ACCOUNT_FIRST_NAME}
                className="accountSetupNode-input accountSetupNode-input-firstName"
              />
            </div>
            <div className="accountSetupNode-inputContainer accountSetupNode-lastName">
              <label className="accountSetupNode-label accountSetupNode-label-lastName">
                Last Name
              </label>
              <input
                id={ELEMENT_IDS.ACCOUNT_LAST_NAME}
                className="accountSetupNode-input accountSetupNode-input-lastName"
              />
            </div>
          </div>
          <div className="accountSetupNode-textRight">
            <input id="accountSetupNode-checkbox" type="checkbox" />
            &nbsp; Text Preferred
          </div>
          <div className="accountSetupNode-inputContainer accountSetupNode-phoneNumber">
            <label className="accountSetupNode-label accountSetupNode-label-phoneNumber">
              Mobile Phone Number
            </label>
            <input
              id={ELEMENT_IDS.ACCOUNT_PHONE}
              className="accountSetupNode-input accountSetupNode-input-phoneNumber"
              value={phone}
              onChange={handlePhoneChange}
              onBlur={validatePhone}
              placeholder="(123)-456-7890"
              maxLength={12}
            />
            {phoneError && (
              <p id="account-phone-error" className="accountSetupNode-errorText" style={{ color: 'red', marginTop: '4px', display: 'none' }}></p>
            )}
            {/* <a
            id={ELEMENT_IDS.ACCOUNT_VERIFY_PHONE_LINK}
            className="accountSetupNode-verifyLink accountSetupNode-verifyPhone"
          >
            Verify Now
          </a> */}
          </div>

          <div className="accountSetupNode-inputContainer accountSetupNode-email">
            <label className="accountSetupNode-label accountSetupNode-label-email">
              Email Address
            </label>
            <input
              id={ELEMENT_IDS.ACCOUNT_EMAIL}
              className="accountSetupNode-input accountSetupNode-input-email"
              type="email"
            />
            <div
              id={ELEMENT_IDS.ACCOUNT_EMAIL_VERIFIED_STATUS}
              className="accountSetupNode-verifiedRow accountSetupNode-emailVerified"
            >
              {/* <span className="accountSetupNode-verified accountSetupNode-emailVerifiedIcon">
              ✔ Verified
            </span> */}
              <span className="accountSetupNode-loginIdNote accountSetupNode-emailLoginNote">
                This email address will be your Login ID.
              </span>
            </div>
          </div>

          <div className="accountSetupNode-inputContainer accountSetupNode-address">
            <label className="accountSetupNode-label accountSetupNode-label-address">
              Address
            </label>
            <input
              id={ELEMENT_IDS.ACCOUNT_ADDRESS}
              className="accountSetupNode-input accountSetupNode-input-address"
              readOnly
              style={{ backgroundColor: '#f0f0f0', color: '#666' }}
            />
          </div>

          <div className="accountSetupNode-inputContainer accountSetupNode-password">
            <label className="accountSetupNode-label accountSetupNode-label-password">
              Create Password
            </label>
            <div className="accountSetupNode-passwordRow">
              <input
                id={ELEMENT_IDS.ACCOUNT_PASSWORD}
                className="accountSetupNode-input accountSetupNode-input-password"
                type={showPassword ? 'text' : 'password'}
              />
              <button
                type="button"
                id={`${ELEMENT_IDS.ACCOUNT_TOGGLE_PASSWORD}_main`}
                className="accountSetupNode-showButton accountSetupNode-togglePassword"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            <div className="accountSetupNode-passwordChecklist">
              <p className="accountSetupNode-passwordChecklistTitle">
                Your password must include the following:
              </p>
              <ul className="accountSetupNode-passwordChecklistItems">
                <li className="accountSetupNode-passwordChecklistItem-green">
                  ✔ Minimum of 8 characters
                </li>
                <li className="accountSetupNode-passwordChecklistItem-green">
                  ✔ Upper and lowercase letters
                </li>
                <li className="accountSetupNode-passwordChecklistItem-green">
                  ✔ At least one number or special character
                </li>
              </ul>
            </div>
          </div>

          <div className="accountSetupNode-inputContainer accountSetupNode-confirmPassword">
            <label className="accountSetupNode-label accountSetupNode-label-confirmPassword">
              Confirm Password
            </label>
            <div className="accountSetupNode-passwordRow">
              <input
                id={ELEMENT_IDS.ACCOUNT_CONFIRM_PASSWORD}
                className="accountSetupNode-input accountSetupNode-input-confirmPassword"
                type={showConfirmPassword ? 'text' : 'password'}
              />
              <button
                type="button"
                id={`${ELEMENT_IDS.ACCOUNT_TOGGLE_PASSWORD}_confirm`}
                className="accountSetupNode-showButton accountSetupNode-togglePassword"
                onClick={toggleConfirmPasswordVisibility}
              >
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>
        </div>

        <div className="accountSetupNode-buttonRow">
          <Button
            customId={ELEMENT_IDS.PREVIOUS_STEP_BUTTON}
            label="Back"
            variant="secondary"
          />
          <Button
            customId={ELEMENT_IDS.CREATE_ACCOUNT_BUTTON}
            label="Create Account"
            right={<span className="accountSetupNode-psnArrow">→</span>}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default SetupAccountNode;
